import { render, staticRenderFns } from "./formBasic.vue?vue&type=template&id=26603b26&scoped=true&"
import script from "./formBasic.vue?vue&type=script&lang=js&"
export * from "./formBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26603b26",
  null
  
)

export default component.exports